import { useState, useEffect } from 'react'
import '../inquiry/telephonic/telephonic.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { UI_CONSTANT, ROUTES_PATH, numbers, monthList } from '../../utility/constants'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import { FilterMatchMode } from 'primereact/api'
import ParentDataTable from '../../components/data-table/ParentDataTable'
import './billingHistory.scss'
import './billingInfo.scss'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import { Avatar } from '@mui/material'
import { Calendar } from 'primereact/calendar'
import CalendarIcon from '../../components/svg/CalendarIcon'
import TableDateInput from '../../components/table-date-input/TableDateInput'
import { FacultyMonthBillPaid, getFacultyMonthBilling } from '../../store/builders/faculty/facultybilling.builder'
import { capitalizeFirstLetter, formatDateToUTCString, generateCSVBlob } from '../../utility/genricFunction'
import dayjs from 'dayjs'
import {
  billingMonthAndYear,
  setCurrentMonthNumber,
  setCurrentYear,
} from '../../store/slice/faculty/facultybilling.slice'
import Loader from '../../components/loader/Loader'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { sendReportMail } from '../../store/builders/reports/reports.builder'

const BillingInfo = () => {
  const dispatch = useDispatch()
  const [profilePhotoPreview, setProfilePhotoPreview] = useState(null)

  const { loading, currentMonthNumber, currentYear } = useSelector((state) => state.facultyMonthBilling)
  const faculty = useSelector((state) => state.facultyMonthBilling?.facultyMonthBillData?.facultyInfo)
  const facultyMonthBillData = useSelector((state) => state.facultyMonthBilling?.facultyMonthBillData?.timeTable)
  const billingCalenderMonthAndYear = useSelector((state) => state.facultyMonthBilling.billingCalenderMonthAndYear)

  const [month, setMonth] = useState(currentMonthNumber)
  const [year, setYear] = useState(currentYear)
  const [date, setDate] = useState(`${monthList[currentMonthNumber - 1]} ${currentYear}`)
  const [isLocked, setIsLocked] = useState(true)

  const { id } = useParams()
  const facultyLastMonthBillingData = facultyMonthBillData?.[facultyMonthBillData.length - 1]
  const isMonthAmountPaid = facultyLastMonthBillingData?.isPaid
  const facultyMonthlyPayment = facultyLastMonthBillingData?.totalAmountForMonth
  const facultyId = id

  useEffect(() => {
    dispatch(getFacultyMonthBilling({ facultyId, month, year }))
    if (faculty?.userPhoto) {
      setProfilePhotoPreview(`${faculty.userPhoto}`)
    }
  }, [facultyId, month, year, dispatch, faculty?.userPhoto])

  useEffect(() => {
    if (billingCalenderMonthAndYear) setDate(billingCalenderMonthAndYear)
  }, [billingCalenderMonthAndYear])

  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)

  const [filteredData, setFilteredData] = useState([])
  const [filterNumber] = useState(false)

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    courseName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    branchName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    amount: { value: null, matchMode: FilterMatchMode.CONTAINS },
    totalHours: { value: null, matchMode: FilterMatchMode.CONTAINS },
    totalAmount: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  const [selected, setSelected] = useState(isMonthAmountPaid)

  const toggleLock = () => {
    setIsLocked(!isLocked)
  }

  useEffect(() => {
    setSelected(isMonthAmountPaid)
  }, [isMonthAmountPaid])

  useEffect(() => {
    setFilteredData(facultyMonthBillData)
  }, [facultyMonthBillData])

  // useEffect(() => {
  //   if (facultyMonthBillData.length !== filteredData.length) {
  //     setfilterNumber(true)
  //   } else {
  //     setfilterNumber(false)
  //   }
  // }, [facultyMonthBillData, filteredData])

  const onFilter = (event) => {
    const newFilters = { ...filters, ...event.filters }
    setFilters(newFilters)
    const filtered = filterData(facultyMonthBillData, newFilters)
    setFilteredData(filtered)
  }

  const filterData = (data, filters) => {
    return data.filter((item) => {
      return Object.keys(filters).every((key) => {
        if (!filters[key].value) return true
        const value = item[key]
        const filterValue = filters[key].value.toLowerCase().trim()
        return value && value.toString().toLowerCase().includes(filterValue)
      })
    })
  }

  const nameBody = (facultyMonthBillData) => {
    const representative = capitalizeFirstLetter(facultyMonthBillData?.branchName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const dateBody = (facultyMonthBillData) => {
    const formatDate = dayjs(facultyMonthBillData?.date).format('DD/MM/YYYY')
    return <span>{formatDate}</span>
  }

  const handleClick = () => {
    const todayDate = formatDateToUTCString(dayjs())
    const billingData = {
      facultyMonthlyPayment,
      todayDate,
      facultyId,
      month,
      year,
      dateFaculty: date,
    }

    if (!selected) {
      setSelected(!selected)
      dispatch(FacultyMonthBillPaid(billingData))
    }
  }

  const columns = [
    {
      sortable: true,
      field: 'date',
      header: 'Date',
      showFilterMenu: false,
      filterMenuStyle: { width: '14rem' },
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by date...',
      filter: true,
      filterElement: TableDateInput,
      body: dateBody,
    },
    {
      sortable: true,
      field: 'courseName',
      header: 'Course',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by course...',
      style: { minWidth: '12rem' },
    },
    {
      sortable: true,
      field: 'branchName',
      header: 'Branch',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by branch...',
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: true,
      field: 'amount',
      header: 'Rate per Hour',
      style: { minWidth: '12rem' },
      filter: true,
      filterPlaceholder: 'Search by rate...',
    },
    {
      sortable: true,
      field: 'totalHours',
      header: 'Hours',
      showFilterMenu: false,
      filterMenuStyle: { width: '14rem' },
      style: { minWidth: '12rem' },
      filter: true,
      filterPlaceholder: 'Search by hours...',
    },
    {
      sortable: true,
      field: 'totalAmount',
      header: 'Total',
      showFilterMenu: false,
      filterMenuStyle: { width: '14rem' },
      style: { minWidth: '12rem' },
      filter: true,
      filterPlaceholder: 'Search by totals...',
    },
  ]

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.FACULTY.LABEL_FACULTY,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.FACULTY.ALL_FACULTY,
      link: ROUTES_PATH.FACULTY,
    },
    {
      title: UI_CONSTANT.BILLING_HISTORY.BILLING_INFORMATION,
      link: ROUTES_PATH.BILLING_INFO_ID.replace(':id', id),
    },
  ]

  function formatDate(date) {
    const monthIndex = date.getMonth()
    const monthNumber = monthIndex + 1
    const month = monthList[monthIndex]
    const year = date.getFullYear()
    dispatch(setCurrentMonthNumber(monthNumber))
    dispatch(setCurrentYear(year))
    setMonth(monthNumber)
    setYear(year)
    return `${month} ${year}`
  }

  function handleDate(date) {
    dispatch(billingMonthAndYear(formatDate(date)))
    setDate(formatDate(date))
  }

  const billingAmountCondition =
    Number(facultyMonthlyPayment) === 0 || facultyMonthlyPayment === undefined ? '₹0' : `₹${facultyMonthlyPayment}`

  const handleSendMail = () => {
    const blob = generateCSVBlob(filteredData, columns)
    dispatch(sendReportMail({ blob, emailData: faculty.userEmail }))
  }
  return (
    <>
      {loading && <Loader loading={loading} />}

      {<Loader loading={loading} /> && (
        <div className={`course-list`}>
          <div className='filter-bar-wraper'>
            <div className='subheader'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
              <button
                type='button'
                onClick={handleClick}
                className={selected ? 'bill-pay-selected' : 'bill-pay-unselected'}
                disabled={Number(facultyMonthlyPayment) === 0 || facultyMonthlyPayment === undefined ? true : false}
              >
                {selected ? UI_CONSTANT.PAID : UI_CONSTANT.UNPAID}
              </button>
            </div>
          </div>

          <div className='group-parent'>
            <div className='frame-wrapper'>
              <div className='course-list-wrapper bill-head'>
                <div className='bill-info-left-head'>
                  <span className='div-img flex align-center'>
                    <Avatar sx={{ height: '28px', width: '28px' }} src={profilePhotoPreview} />
                    <b className='course-list-bill bill-name'>{faculty?.userName}</b>
                  </span>
                  <p className='bill-detail'>Billing information for {monthList[month - 1]} month</p>
                </div>
                {isLocked && <LockOutlinedIcon className='billing-info-lock' onClick={toggleLock} />}
                <div className={`bill-div ${!isLocked ? '' : 'blur'}`}>
                  <span className='right-bill-txt'>
                    <div className='billing-info-calendar-wrapper flex flex-column'>
                      <Calendar
                        className='calendar-container'
                        value={date}
                        onChange={(e) => handleDate(e.value)}
                        view='month'
                        dateFormat='mm/yy'
                        showIcon
                        icon={<CalendarIcon />}
                        iconPos='left'
                      />
                    </div>
                    <span className='bill-amt-txt'>{date} Total</span>
                  </span>
                  <p className='bill-amt'>{billingAmountCondition}</p>
                  <p className='mail-txt'>{UI_CONSTANT.SEND_MAIL}</p>
                </div>
              </div>
            </div>
            <div className='flex page-drop-div'>
              <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
              <PageDropdown
                options={numbers}
                selectedValue={selectedNumber}
                onChange={(e) => setSelectedNumber(e.value)}
                className='w-full md:w-14rem small-dropdown'
              />
              <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
            </div>

            <div className={`table-card ${!isLocked ? '' : 'blur'}`}>
              <ParentDataTable
                value={filteredData}
                rows={filterNumber ? filteredData.length : selectedNumber}
                filters={filters}
                // loading={loading}
                columns={columns}
                onFilter={onFilter}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default BillingInfo
